export default __webpack_public_path__ + "static/media/img1.5b7fed69.jpg";